// extracted by mini-css-extract-plugin
export default {"root":"LkRvyLrX3ZQHKFN7q9ab","label":"C0vMaiSsvfpoID4UEKVw","invalid":"WNz3ZrCNG2BaISDTz7cy","valid":"klTSHmrEX7bfpDyq5oeh","error":"iS_VyHnEakJdBy0nLa6g"};